import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { isObservable, lastValueFrom, Observable } from 'rxjs';

import { FilterComponentModel } from 'src/app/models/filter-component.model';

@Component({
  selector: 'app-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.scss'],
})
export class DropdownFilterComponent implements OnInit, OnChanges {
  @Input() label = '';
  @Input() options: any[] | Observable<any[]> = [];
  @Input() displayProperty = '';
  @Input() field = '';
  @Input() styleClass = '';
  @Input() filterContent = true;
  @Input() filter: FilterComponentModel = {
    field: '',
    title: '',
    open: false,
    values: [],
    displayAs: 'dropdown',
  };
  @Input() value: any | undefined;
  @Input() required = false;
  @Input() displayAs: 'dropdown' | 'CarType' | 'input' = 'CarType';

  @Output() selectionEmmiter: EventEmitter<any> = new EventEmitter();

  allStyleClass = '';
  selectedOptions: any[] = [];
  form: FormGroup;
  control: FormControl;
  fb: FormBuilder;

  suggestions: any[] = [];

  constructor() {
    this.fb = new FormBuilder();
    this.control = new FormControl(this.value);
    this.form = new FormGroup({ control: this.control });
    this.allStyleClass = `${this.styleClass} trm-filter-dropdown`;
  }

  ngOnInit(): void {
    if (this.required) {
      this.control.addValidators(Validators.required);
      this.control.markAsDirty();
    }
    this.control.setValue(this.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.control.setValue(this.value);
    }
  }

  getFilterFn(query: string, options: any[]) {
    if (query.length === 0 || !query) {
      return (option: string) => true;
    }
    switch (typeof options[0]) {
      case 'number': {
        return (option: number) => true;
      }
      case 'string': {
        return (option: string) => option.toLowerCase().includes(query);
      }
    }
    return (option: { [x: string]: string }) =>
      option[this.displayProperty].toLowerCase().includes(query) ||
      option[this.displayProperty] === 'Other';
  }

  async setFilter(event: any) {
    const resOptions = isObservable(this.options)
      ? await lastValueFrom(this.options)
      : this.options;

    if (!this.filterContent) {
      this.suggestions = resOptions.filter((option: string) => true);
      return;
    }

    const query: string = event.query.trim().toLowerCase();

    const filterFn = this.getFilterFn(query, resOptions);
    this.suggestions = resOptions.filter(filterFn);
  }

  selectDropdown(selected: any) {
    this.select(selected.value);
  }

  selectInput() {
    const trimmedValue = this.control.value.trim();
    this.control.setValue(trimmedValue);
    this.select(trimmedValue);
  }

  select(selected: any) {
    const outputObj =
      this.filter.displayAs === 'range'
        ? { selected, filter: this.filter, range: this.label }
        : { selected, filter: this.filter };
    this.selectionEmmiter.emit(outputObj);
  }
}
